import { useParams } from "react-router-dom";
import { useGetAssignmentQuery } from "../../../../features/assignment/assignmentApi";
import EmptyResult from "../../../ui/EmptyResult";
import Error from "../../../ui/Error";
import Loading from "../../../ui/Loading";
import EditAssignmentForm from "./EditAssignmentForm";

export default function EditAssignment() {
	const { assignmentId } = useParams();
	const {
		data: assignment,
		isLoading,
		isError,
	} = useGetAssignmentQuery(assignmentId) || {};

    // Decide what to render
    let content = null;
    if (isLoading) {
        content = <Loading />;
    }
    else if (!isLoading && isError) {
        content = <Error message="There was an error!" />;
    }
    else if (!isLoading && !isError && assignment === undefined) {
        content = <EmptyResult message="Sorry the assignment is not found!" />;
    }
    else if (!isLoading && !isError && assignment !== undefined) {
        content = <EditAssignmentForm assignment={assignment} />
    }

	return (
        <section className="py-6 bg-primary place-items-center">
			<div className="mx-auto max-w-5xl px-5 lg:px-0">
				{content}
			</div>
		</section>
    );
}
